import { app } from 'application';
import { useEffect, useState } from 'react';
import { autorun } from 'mobx';

interface UseAuthentication {
  authed: boolean | undefined;
}

export function useAuthentication(): UseAuthentication {
  const [authed, setAuthed] = useState<boolean | undefined>((): boolean | undefined => {
    return app().userStore.authed;
  });

  useEffect((): Unsubscribe => {
    const disposer = autorun(() => {
      setAuthed(app().userStore.authed);
    });

    return () => disposer();
  }, []);

  useEffect((): void => {
    if (!authed) {
      void app().userStore.authenticate();
    }
  }, [authed]);

  return {
    authed,
  };
}
